import { Injectable, inject } from "@angular/core";

import { Observable, map } from "rxjs";

import { InitSettings, Round, RoundFair, RoundPlay } from "@models";
import { Utils } from "@utils";

import { APP_CONFIG, HttpService } from "./http.service";

interface HistoryResp {
  rounds: Round[];
}

interface InitResp {
  settings: InitSettings;
}

interface ActionResp {
  round_id: string;
}

@Injectable({ providedIn: "root" })
export class GameService extends HttpService {
  protected apiUrl = inject(APP_CONFIG).engineUrl;

  protected domain = "game";

  public history(): Observable<Round[]> {
    return this.post<HistoryResp>("/history", { limit: Utils.limit, with_state: true }).pipe(map(resp => resp.rounds));
  }

  public fair(round_id: string): Observable<RoundFair> {
    return this.post<RoundFair>("/history/provably-fair", { round_id });
  }

  public play(body: RoundPlay): Observable<string> {
    return this.post<ActionResp>("/action", body).pipe(map(resp => resp.round_id));
  }

  public init(): Observable<InitSettings> {
    return this.get<InitResp>("/init").pipe(map(resp => resp.settings));
  }
}
